// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"189": "ed590f5dfbec7ea1","26": "892673f23e2b4c30",}[chunkId] + ".js"
}